import { quickCards } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Moody%20abstract%20cinematic%20background%20of%20a%20dark%20movie%20theater%20interior%20with%20rows%20of%20empty%20seats%2C%20warm%20amber%20and%20deep%20red%20bokeh%20lights%2C%20soft%20projector%20light%20beam%20in%20the%20distance%2C%20elegant%20atmospheric%20texture%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=bajie-hero-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/65 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-28 md:pt-32 pb-14 md:pb-20">
        <div className="max-w-6xl mx-auto">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-50/90 text-xs md:text-sm animate-fadeIn">
            <i className="ri-movie-2-line" aria-hidden="true"></i>
            地址与访问指南 · 持续更新
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl leading-tight text-background-50 max-w-3xl animate-fadeUp">
            八戒影院最新地址与官方入口指引
          </h1>

          <p className="mt-5 text-sm md:text-base leading-relaxed text-background-50/80 max-w-2xl animate-fadeUp">
            这里汇总八戒影院最新地址和官方网址入口，专门解决「打不开」「域名失效」这类问题。
            无论你是想找当前可用的访问入口、核对官方网址，还是了解 App 下载方式与新域名访问路径，
            都能在这个页面按顺序找到对应的说明和备用方案。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3 animate-fadeUp">
            <a
              href="#address"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-map-pin-2-line" aria-hidden="true"></i>
              查看最新地址
            </a>
            <a
              href="#troubleshoot"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/25 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-tools-line" aria-hidden="true"></i>
              打不开怎么办
            </a>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {quickCards.map((card) => (
              <a
                key={card.title}
                href={card.href}
                className="group block p-4 md:p-5 rounded-lg bg-background-50/10 border border-background-50/15 backdrop-blur-sm cursor-pointer hover:bg-background-50/20 transition-colors"
              >
                <div className="w-10 h-10 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center">
                  <i className={`${card.icon} text-lg`} aria-hidden="true"></i>
                </div>
                <h3 className="mt-4 font-heading text-base text-background-50">{card.title}</h3>
                <p className="mt-2 text-xs md:text-sm leading-relaxed text-background-50/75">
                  {card.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-accent-300">
                  前往查看
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" aria-hidden="true"></i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}